import { render } from "./LoadingIndicator.vue?vue&type=template&id=7fc9cc8c&ts=true"
import script from "./LoadingIndicator.vue?vue&type=script&lang=ts"
export * from "./LoadingIndicator.vue?vue&type=script&lang=ts"

import "./LoadingIndicator.vue?vue&type=style&index=0&id=7fc9cc8c&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__